import React, { useState, useEffect } from "react";
import { CiUser, CiEdit, CiTrash, CiBookmark } from "react-icons/ci";
import { LuSignalMedium } from "react-icons/lu";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { MdOutlineSignalCellularAlt } from "react-icons/md";
import Utils from "../../utils/utils";
import { useToast } from "../ToastContext";
import { useAppLibs } from "../../ContextProvider/AppLib_Provider";
import DocumentList from "./DocumentList";

const AdminProjectCard = ({ item, index, onEdit, onView, setProjects }) => {
  // const { item, index, onEdit, onView, setAssignments } = props;
  const { Projects } = useAppLibs();
  const showToast = useToast();
  const LEVEL = Projects.LEVEL;
  const SUBJECT = Projects.SUBJECT;
  var difficulty = LEVEL[item.level];
  const [showDocs, setShowDocs] = useState(false);

  // == Handlers
  const HandlePublishProject = async (id) => {
    const confirm = window.confirm(
      "Are you sure ? \nOnce the project has been publish you can't Edit and Delete !"
    );
    if (!confirm) return;
    const result = await Projects.publishProject(id, { publish: true });
    try {
      if (result.success) {
        const updated = result.data;
        showToast("Success", "success", true, 3000);
        setProjects((prev) => prev.map((x) => (x._id === id ? updated : x)));
      } else {
        showToast(result.error, "error", true, 5000);
        return;
      }
    } catch (error) {
      showToast(error.error, "error", true, 5000);
    }
  };

  const HandleDeleteProject = async (id) => {
    const confirm = window.confirm("Are you sure ?");
    if (!confirm) return;
    const result = await Projects.deleteProject(id);
    try {
      if (result.success) {
        showToast("Success", "success", true, 3000);
        setProjects((prev) => prev.filter((x) => x._id !== id));
      } else {
        showToast(result.error, "error", true, 5000);
        return;
      }
    } catch (error) {
      showToast(error.error, "error", true, 5000);
    }
  };

  return (
    <div
      bkl={"AdminProjectCard" + item._id}
      key={`AdminAssignmentCard-${item._id}-${index * index}`}
      className="group relative mb-4 overflow-hidden rounded-xl border bg-white p-6 transition-all hover:shadow-lg"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div
        className="
        absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-pink-600 to-pink-800"
      />

      <div key={"AdminAssignmentCardView" + index} className="">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
          <div className="order-2 flex-1 space-y-4 sm:order-1 ">
            <div>
              <h3 className="font-semibold text-gray-900">{item.title}</h3>
              {item.description && (
                <p className="mt-1 text-sm text-gray-600">{item.description}</p>
              )}
              {item.instruction && (
                <p className="mt-2 text-sm italic text-gray-500">
                  {item.instruction}
                </p>
              )}
            </div>
          </div>

          <div className="order-1 flex flex-col gap-3 sm:order-2 ">
            <div className="flex gap-2 justify-end">
              <button
                className="inline-flex items-center gap-1 rounded-lg border border-blue-200 px-3 py-1.5 text-xs font-medium tracking-wide text-blue-600 transition-colors hover:bg-blue-50"
                onClick={onEdit}
              >
                <CiEdit size={14} /> EDIT
              </button>
              {!item.publish && (
                <button
                  className="inline-flex items-center gap-1 rounded-lg border border-red-200 px-3 py-1.5 text-xs font-medium tracking-wide text-red-600 transition-colors hover:bg-red-50"
                  onClick={(e) => {
                    e.stopPropagation();
                    HandleDeleteProject(item._id);
                  }}
                >
                  <CiTrash size={14} /> Delete
                </button>
              )}
            </div>

            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                item.publish ? onView() : HandlePublishProject(item._id);
              }}
              className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium tracking-wide text-white transition-all hover:bg-blue-700 hover:tracking-wider"
            >
              {item?.publish ? "VIEW SUBMISSIONS" : "PUBLISH"}
            </button>
          </div>
        </div>

        <div className="mt-2 flex items-center gap-2 text-sm text-gray-600">
          <CiBookmark size={16} />
          <span className="color">{SUBJECT[item?.subject]}</span>
        </div>

        <div className="mt-2 flex items-center gap-2 text-sm text-gray-600">
          <MdOutlineSignalCellularAlt size={16} />
          <button
            disabled
            className={` px-2 py-1 shadow ${difficulty.text} ${difficulty.bg} rounded`}
          >
            {difficulty.name}
          </button>
        </div>
        <div className="mt-2 flex items-center gap-2 text-sm text-gray-600">
          <CiUser size={16} />
          <span>{item?.createdBy.split("+")[1]}</span>
        </div>
      </div>

      <div className="mt-4">
        <div className="flex justify-between">
          <button
            onClick={() => setShowDocs(!showDocs)}
            className="inline-flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-gray-900"
          >
            Documents
            {showDocs ? (
              <FaChevronUp className="mt-1" />
            ) : (
              <FaChevronDown className="mt-1" />
            )}
          </button>
          <button
            disabled
            className="inline-flex  items-center gap-2 text-sm font-medium text-gray-700 hover:text-gray-900"
          >
            Max Marks :{" "}
            <span> {item.maxMarks >= 0 ? item.maxMarks : "N/A"} </span>
          </button>
        </div>
        {showDocs && (
          <div className="mt-4 rounded-lg border border-gray-200 bg-gray-50 p-4">
            <DocumentList
              props={{
                projectId: item._id,
                documents: item.docs,
                project: item,
                setProjects,
              }}
            />
          </div>
        )}
      </div>
      <span className="text-xs text-gray-600 mt-1 -mb-3  italic flex">
        {Utils.formatDateTime(item.createdAt)}
      </span>
    </div>
  );
};

export default AdminProjectCard;
